import { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import DynamicContent from "../../../components/DynamicContent";
import { getPage } from "ab-api-queries";

const NuestraEsencia = ({ content, moduloCross }) => {
  const { i18n } = useTranslation("common");
  // console.log("NuestraEsencia  ", content);

  const [isSticky, setIsSticky] = useState(false);
  const handleSticky = () => {
    if (window.pageYOffset > window.innerHeight - 90) {
      document.getElementById("ab-historia-menu")?.classList.add("sticky");
      setIsSticky(true);
    } else {
      document.getElementById("ab-historia-menu")?.classList.remove("sticky");
      setIsSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleSticky);

    if (window.pageYOffset > window.innerHeight - 90) {
      document.getElementById("ab-historia-menu")?.classList.add("sticky");
      setIsSticky(true);
    } else {
      document.getElementById("ab-historia-menu")?.classList.remove("sticky");
      setIsSticky(false);
    }

    return () => {
      window.removeEventListener("scroll", handleSticky);
    };
  }, []);

  return (
    <>
      {content?.map((itm, index) => {
        return (
          <>
            <DynamicContent
              {...itm}
              rtl={index % 2 !== 1}
              moduloCross={moduloCross}
              key={`${itm.fieldGroupName}-${index}`}
              i18n={i18n}
            />
          </>
        );
      })}
    </>
  );
};

export async function getServerSideProps({ locale }) {
  const data = await getPage(`tienda/nuestra-esencia`);

  // const locale = getLocaleFromContext(context);
  // const redirectURL = getLinkFromTranslation(data?.nodeByUri?.translations, locale);

  // if (locale != 'es' && redirectURL) {
  //   return {
  //     redirect: {
  //       permanent: false,
  //       destination: redirectURL
  //     }
  //   };
  // }

  const translations = await serverSideTranslations(locale, ["common"]);

  return {
    props: {
      seo: data?.nodeByUri?.seo || null,
      content: data?.nodeByUri?.contenidoFlexible?.modulos || [],
      moduloCross: data?.modulosCross || null,
      footer: data?.headerFooter?.footer || null,
      menu: data?.headerFooter?.menu || null,
      translations: data?.nodeByUri?.translations || null,
      language: data?.nodeByUri?.language || null,
      ...translations,
    }, // will be passed to the page component as props
    notFound:
      !data?.nodeByUri?.contenidoFlexible?.modulos.length > 0 ||
      locale !== "es",
  };
}

export default NuestraEsencia;
